const settings = {
  title: 'Nastavitve',
  profile: 'Profil',
  signOut: 'Odjava',
  saved: 'Nastavitve shranjene',
  errorSaving: 'Napaka pri shranjevanju nastavitev',

  versionInfo: 'Različica aplikacije',
  versionInfoDescription:
    'Podpora vas lahko prosi za te številke pri odpravljanju napak.',
  nativeVersion: 'Različica aplikacije',
  buildNumber: 'Interna različica',
  bundleVersion: 'Različica paketa',
  unknown: 'Neznano',

  appSettings: 'Nastavitve aplikacije',
  transcriptionSettings: 'Nastavitve nareka',

  changeLanguage: 'Spremeni jezik',
  context: 'Za umetno inteligenco težko razumljivi izrazi',
  contextPlaceholder: 'Xanax, Lekadol, miokardij, ...',
  specialization: 'Specializacija',
  specializationPlaceholder: 'kardiologija, endokrinologija, ...',
  clinic: 'Ambulanta',
  clinicPlaceholder: 'splošna ambulanta, kardiologija, ...',
  customTemplates: 'Predloge po meri',
  contactUsDescription:
    'Za predloge po meri in integracije programske opreme, nam pišite na ',
  contactUsButton: 'Kontakt',

  subscription: {
    title: 'Naročnina',
    used_one: 'Porabljen {{count}} od {{max}} brezplačnih izvidov ta mesec.',
    used_two: 'Porabljena {{count}} od {{max}} brezplačnih izvidov ta mesec.',
    used_few: 'Porabljeni {{count}} od {{max}} brezplačnih izvidov ta mesec.',
    used_other:
      'Porabljenih {{count}} od {{max}} brezplačnih izvidov ta mesec.',
    subscribedPrefix: 'Naročeni ste na ',
    subscribedSuffix: '.',
    manage: 'Upravljaj naročnino',
    manageSubscriptionError: 'Upravljanje naročnine ni uspelo.',
    subscribe: 'Naroči se',
    restorePurchase: 'Obnovitev nakupov',
    restoringPurchases: 'Obnavljanje nakupov...',
    purchasesRestoredSuccessfully: 'Nakupi uspešno obnovljeni',
    noPurchasesFound: 'Ni najdenih nakupov',
    privacyPolicy: 'Politika zasebnosti',
    termsOfService: 'Pogoji uporabe',
    packages: {
      $rc_monthly: 'Pro - mesečno ({{price}})',
      $rc_annual: 'Pro - letno ({{price}})',
    },
  },
};

export default settings;
